import { Component, inject, Input, OnInit } from '@angular/core';
import { BaseComponent, WmsTreeComponent }  from '@wms/components';
import { CommonModule } from '@angular/common';
import { BindVariableService, DialogService, TypeFactoryService } from '@wms/services';
import { BaseVariableService } from '@wms/variables';
import { forEach } from 'lodash-es';

@Component({
  standalone: true,
  selector: 'wms-bind-variable-tree',
  templateUrl: './bind-variable-tree.component.html',
  styleUrls: ['./bind-variable-tree.component.less'],
  imports: [ WmsTreeComponent, CommonModule ]
})
export class BindVariableTreeComponent extends BaseComponent implements OnInit {
  @Input() variableSearchKey?: any;
  @Input() message?: any;
  @Input() typeVariablesNotFound?: any;
  @Input() hideChildren?: boolean;
  @Input() skipChildNodeSearch?: boolean;
  @Input() variablePanel?: boolean;
  actionVariables = ['wm.LoginVariable', 'wm.LogoutVariable', 'wm.NavigationVariable', 'wm.NotificationVariable', 'wm.TimerVariable']
  private typeService = inject(TypeFactoryService);

  sortOrder: any = 'desc';

  constructor(public bindVariableService: BindVariableService, private dialogService: DialogService, private baseVariableService: BaseVariableService) {
    super();
   }

  ngOnInit(): void {
  }

  openVariableDialog($event: any) {
    forEach(this.baseVariableService.variableCollection, (val, key) => {
      if (this.baseVariableService.variableCollection[key][$event?.dataItem.id]) {
        if (!this.baseVariableService.selectedVariable)
          this.baseVariableService.selectedVariable = {};
        this.baseVariableService.selectedVariable['variableObject'] = this.baseVariableService.variableCollection[key][$event?.dataItem.id];
        return;
      }
    });
    if (this.actionVariables.includes(this.baseVariableService.selectedVariable['variableObject']?.category)) {
      this.baseVariableService.selectedVariableView = 'Actions';
    }
    this.dialogService.open('variableModal');
  }
}
